import { TournamentState } from '@ps/poker-games-tile-mappers';
import type { TranslationTag } from '@ps/web-core-intl';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { useCountdown } from '@swf/poker';

import { usePokerSundayMillionWidget } from '../../../model';
import CountdownTile from '../CountdownTile/CountdownTile';

import { TXTCLI_Days, TXTCLI_Hours, TXTCLI_Mins, TXTCLI_Secs } from './Countdown.messages.json';
import styles from './Countdown.scss';

const labels: TranslationTag[] = [TXTCLI_Days, TXTCLI_Hours, TXTCLI_Mins, TXTCLI_Secs];

const Countdown: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const state = useSelector(widgetSelect.getTournament)?.formattedState;
  const date = useSelector(widgetSelect.getTimerDate);
  const isLoading = useSelector(widgetSelect.isLoading);
  const countdown = useCountdown(date);
  const isHydrated = useSelector(widgetSelect.isHydrated);

  const showCountdown = [
    TournamentState.ANNOUNCED,
    TournamentState.LATE_REGISTRATION,
    TournamentState.REGISTERING,
    TournamentState.SEATING
  ].includes(state);

  const data = Object.values(countdown).map((value, idx) => (
    <CountdownTile key={labels[idx].id} label={labels[idx]} value={value} />
  ));

  if (!isHydrated || !showCountdown || isLoading) return null;

  return (
    <div className={styles.root}>
      <div
        className={classNames(styles.countdown, {
          [styles.lateReg]: state === TournamentState.LATE_REGISTRATION
        })}
      >
        {data}
      </div>
    </div>
  );
};

export default Countdown;
